import { Select, Typography } from 'antd';
import { Card } from '@insight-health-ai/roseate/components';

import type { MagicFlowOption } from 'src/models';

type Props = {
  value?: string;
  options: MagicFlowOption[];
  onChange: (recipeId?: string) => void;
  disabled?: boolean;
};

// Right-rail card on the create-flow page that exposes the "start from a
// recipe" affordance prominently. Until this lived as one inline form item
// inside Flow Settings it was easy to miss; promoting it to its own card
// makes prefill the obvious first step.
export const MagicFlowRecipePrefillCard = ({
  value,
  options,
  onChange,
  disabled,
}: Props) => (
  <Card title="Start from a recipe" padding={{ body: 'sm', header: 'sm' }}>
    <Typography.Paragraph type="secondary" className="!mb-3 text-sm">
      Pick a recipe to pre-fill steps, triggers, and custom variables for this
      flow. You can still edit everything afterwards.
    </Typography.Paragraph>
    <Select
      className="w-full"
      showSearch
      allowClear
      options={options}
      value={value}
      onChange={(next) => onChange(next || undefined)}
      placeholder="Pick a recipe…"
      optionFilterProp="label"
      disabled={disabled}
    />
    {value ? (
      <Typography.Paragraph type="secondary" className="!mt-3 !mb-0 text-xs">
        Steps, triggers and custom variables on the left have been pre-filled
        from this recipe. Selecting a different recipe (or clearing this) will
        overwrite them.
      </Typography.Paragraph>
    ) : (
      <Typography.Paragraph type="secondary" className="!mt-3 !mb-0 text-xs">
        Or skip this and author the flow from scratch on the left.
      </Typography.Paragraph>
    )}
  </Card>
);
